export default __webpack_public_path__ + "static/media/Survivor_Icon.4e06d59c.png";